export const SidebarItems = [
    {
        name: "Familie",
        route: '/',
        image: "/favicon.ico",
        isSubItem: false
    },
    {
        name: "Ukeplaner",
        route: '/weekschedulekids',
        isSubItem: true
    },
    {
        name: "Ukepenger",
        route: '/weeklyAllowance',
        isSubItem: true
    },
    {
        name: "Hoppetau",
        route: '/exercise',
        isSubItem: true
    },
    {
        name: "Push-ups",
        route: '/pushups',
        isSubItem: true
    },
    {
        name: "Handleliste",
        route: '/shoppingList',
        isSubItem: true
    },
    {
        name: "Admin",
        route: '/admin',
        isSubItem: true
    },
    {
        name: "Sivert",
        route: '/sivert',
        image: "/images/Sivert.png",
        isSubItem: false
    },
    {
        name: "Jenny",
        route: '/jenny',
        image: "/images/Jenny.png",
        isSubItem: false
    }
];
